import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ExceptionManager } from "../../../../../../../config/helpers/Logging";
import { endpoints } from "../../../../../../../config/constants";
import { resetALL } from "../../../../../../../config/redux/actions";
import { clientMutation, clientQuery } from "../../../../../../../config/helpers/GraphQLApi";



//STATE INITIAL
const INIT_STATE = {
    loading: false,
    data: null,
    result: null,
    error: null,
};

const route = "modules/management/parameters/components/cronConfig/redux/slice";

export const getCronConfig = createAsyncThunk('parameters/components/cronConfig/getCronConfig', async (
    _,{ rejectWithValue, dispatch }
) => {
    try {
        let data = await clientQuery(
            `query getCronConfig {
                result: getCronConfig {
                  cronCampaigns {
                    interval
                    lastExecution
                  }
                }
              }`,
            { },
            endpoints.GRAPHQL_GENERAL
        )

        return data?.result
    } catch (exc) {
        ExceptionManager(exc, route, 'getCronConfig', dispatch);
        return rejectWithValue(exc)
    }
})

export const updateCronConfig = createAsyncThunk('parameters/components/cronConfig/updateCronConfig', async (
    { cronName, value },
    { rejectWithValue, dispatch }
) => {
    try {
        let data = await clientMutation(
            `mutation updateCronConfig($cronName: CronName!, $value: Int!) {
                result: updateCronConfig(cronName: $cronName, interval: $value)
              }`,
            { cronName, value },
            endpoints.GRAPHQL_GENERAL
        )

        return data?.result
    } catch (exc) {
        ExceptionManager(exc, route, 'updateCronConfig', dispatch);
        return rejectWithValue(exc)
    }
})

//Slice
const cronConfigRedux = createSlice({
    name: 'parameters/components/cronConfig',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE)

        builder.addCase(updateCronConfig.pending, (state) => {
            state.loading = true
            state.result = null
        })
        builder.addCase(updateCronConfig.fulfilled, (state, { payload }) => {
            state.loading = false
            state.result = payload
        })
        builder.addCase(updateCronConfig.rejected, (state, action) => {
            state.loading = false
            state.error = action.error.message
        })

        builder.addCase(getCronConfig.pending, (state) => {
            state.loading = true
        })
        builder.addCase(getCronConfig.fulfilled, (state, { payload }) => {
            state.loading = false
            state.data = payload
        })
        builder.addCase(getCronConfig.rejected, (state, action) => {
            state.loading = false
            state.error = action.error.message
        })

    },
})

// Extract and export the action creators object and the reducer
export const { actions, reducer } = cronConfigRedux;

// Extract and export each action creator by name
export const { reset } = actions

//Simple async action

// Export the reducer, either as a default or named export
export default reducer



